<template>
  <v-card to="/mission" class="px-2">
    <v-card-title> Company {{ t("mission.title") }} </v-card-title>
    <v-card-subtitle>
      Manage and monitor your {{ t("mission.title") | lower }}
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-slide-group show-arrows>
            <v-slide-item>
              <avatar
                size="100"
                cssClass="mr-4 text-h3 cursor-pointer"
                :badgeUrl="company.missionStatementBadgeUrl"
                :fill="$vuetify.theme.themes.light.secondary"
              >
                <template v-slot:tooltip>
                  {{ t("mission.title") }} Statement
                </template>
              </avatar>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MissionStatementCard",
  components: {},
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({
      company: "company/company"
    })
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group__wrapper {
  padding-top: 16px;
  padding-bottom: 16px;
}
</style>
